const SERVER_ENDPOINT = 'https://api.vitay.io';
import packageInfo from '../../package.json';
import { VALIDITY_SCREENING_CONFIG } from './validity.environment';

export const environment = {
  HELP_SCOUT_ID: '2dd0e0c9-b62d-45d2-8811-e3f5fa17612d',
  VERSION: packageInfo.version,
  FB_PIXEL: {
    IS_ENABLED: true,
    PIXEL_ID: '246202623555291'
  },
  ENDPOINTS: {
    SOCKET: 'wss://api.vitay.io/cable',
    ASSETS: 'https://assets.vitay.io',
    BACK_END: {
      V1: `${SERVER_ENDPOINT}/api/v1`,
      V2: `${SERVER_ENDPOINT}/api/v2`,
      V3: `${SERVER_ENDPOINT}/api/v3`
    },
    FRONT_END: {
      ADMIN: 'https://admin.vitay.io',
      APP: 'https://app.vitay.io',
      CONFIGURATION: 'https://configuration.vitay.io',
      FEEDBACK: 'https://feedback.vitay.io',
      IFRAME: 'https://iframe.vitay.io',
      JOBS: 'https://jobs.vitay.io',
      REFERENCES: 'https://references.vitay.io'
    }
  },
  ENABLE_SERVICE_WORKER: true,
  ENVIRONMENT: 'production',
  IP_INFO: 'bd86ce9ca31822',
  IS_PRODUCTION: true,
  SERVER_ENDPOINT,
  GOOGLE_ANALYTICS: {
    domain: '',
    GTM: ''
  },
  VALIDITY_SCREENING: {
    PRODUCTS: VALIDITY_SCREENING_CONFIG.PROD.PRODUCTS
  },
  SENTRY: {
    DNS: 'https://01d8b62059b8462ede398afd1946e549@o4508258504212480.ingest.us.sentry.io/4508264190246912',
    TRACE_URL: ['localhost', /^https:\/\/api\.vitay\.(co\.uk|io|ca)\/api\/$/]
  }
};
